__webpack_require__.p = "https://assets.mindtickle.com/ui-shell/prod/production/";